import SentryClient from './SentryClient'
import { parseJson, parseError } from './helper'

export function captureRequestException(errorMessage, error, extraData = {}) {
  SentryClient.captureRequestException({
    errorMessage,
    error: parseError(error),
    extraData
  })
}

export function captureExceptionWithScope(
  exception,
  extraKey,
  extraData,
  tags = {},
  level = 'error'
) {
  SentryClient.captureExceptionWithScope(
    exception,
    {
      extraKey,
      extraData: {
        ...extraData,
        error: parseError(extraData.error)
      },
      tags
    },
    level
  )
}
